import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { IntuitiveToothForDiagram } from '../../models';
import { RxIntuitiveToothComponent } from '../rx-intuitive-tooth/rx-intuitive-tooth.component';

@Component({
	selector: 'rx-intuitive-teeth-diagram',
	templateUrl: './rx-intuitive-teeth-diagram.component.html',
	styleUrls: ['./rx-intuitive-teeth-diagram.component.scss'],
	standalone: true,
	changeDetection: ChangeDetectionStrategy.OnPush,
	imports: [CommonModule, TranslateModule, RxIntuitiveToothComponent],
	host: {
		'[attr.tabindex]': 'hostTabIndex'
	}
})
export class RxIntuitiveTeethDiagramComponent {
	readonly hostTabIndex = '-1';

	@Input() upperJaw: IntuitiveToothForDiagram[] = [];
	@Input() lowerJaw: IntuitiveToothForDiagram[] = [];
	/** When true, tooth taps do not change selection (shell / teethDiagram read-only). */
	@Input() chartReadOnly = false;

	@Output() toothClicked = new EventEmitter<number>();
	@Output() resetSelectedRequested = new EventEmitter<void>();

	getDisplayNumber(tooth: IntuitiveToothForDiagram): string | number {
		return tooth.toothNumberInSystem;
	}

	onToothClicked(toothId: number): void {
		if (this.chartReadOnly) {
			return;
		}

		this.toothClicked.emit(toothId);
	}

	onResetSelectedRequested(): void {
		if (this.chartReadOnly) {
			return;
		}

		this.resetSelectedRequested.emit();
	}

	toothIdTrackBy(index: number, tooth: IntuitiveToothForDiagram): number {
		return tooth.toothId;
	}
}
